import styles from "./App.module.css";
import {useVhProperty} from "./assets/AdditionalFunctions/SetValueVh";
import TextsContext from "./assets/ContextProvider/TextsContent";
import texts from "./assets/ContextProvider/textsLocalized.json";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import Header from "./components/Header/Header";
import Login from "./pages/Login/Login";
import Preferences from "./pages/Preferences/Preferences";
import Welcome from "./pages/Welcome/Welcome";
import Movies from "./pages/Movies/Movies";
import NonUserViewMovie from "./pages/NonUserViewMovie/NonUserViewMovie";
import {usePreventingScale} from "./assets/AdditionalFunctions/PreventingScaleByDoubleClick";
import Favorites from "./pages/Favorites/Favorites";

import TestTMDB from "./pages/TestTMDB";
import GenerationType from "./pages/GenerationType/GenerationType";
import Contact from "./pages/Contact/Contact";
import Terms from "./pages/Terms/Terms";
import MoviesNews from "./pages/MoviesNews/MoviesNews"; //for testing TMDb api from frontend

function App() {
  useVhProperty();
  usePreventingScale();

  const location = useLocation();
  const pathName = location.pathname;

  return (
    <div className="App">
      <TextsContext.Provider value={texts}>
        {!pathName.includes("/shared/") ? <Header/> : null}
        <Routes>
          <Route path="/" element={<Login/>}/>
          <Route path="welcome" element={<Welcome/>}/>
          <Route path="preferences" element={<Preferences/>}/>
          <Route path="movies" element={<Movies/>}/>
          <Route
            path="/shared/:token"
            element={<NonUserViewMovie/>}
          />
          <Route path="favorites" element={<Favorites/>}/>
          <Route
            path="generation-type"
            element={<GenerationType/>}
          />
          <Route path="contact" element={<Contact/>}/>
          <Route path="terms" element={<Terms/>}/>
          <Route path="movie-news" element={<MoviesNews/>}/>

          <Route path="/test-tmdb" element={<TestTMDB/>}/>
        </Routes>
      </TextsContext.Provider>
    </div>
  );
}

export default App;
